import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { selectDepartmentById } from '../../features/departments/departmentsSlice';
import { useIsMobile } from '../../hooks/useIsMobile';

const StaffModal = ({ departmentId, show, handleClose, children }) => {
	const { isMobile } = useIsMobile();
	const labels = useLabels();
	const department = useSelector((state) =>
		selectDepartmentById(state, departmentId)
	);

	return (
		<div>
			<Modal
				show={show}
				onHide={handleClose}
				// d-flex in className + m-auto in dialogClassName centers modal in both x and y axes for desktop
				className={isMobile ? 'modal dock-right no-slide' : 'd-flex'}
				dialogClassName={isMobile ? ' ' : 'm-auto'}
			>
				<Modal.Header closeButton>
					<Modal.Title componentClass="h3">
						{labels.get(department.label)}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="p-0">{children}</Modal.Body>
			</Modal>
		</div>
	);
};

// Define PropTypes
StaffModal.propTypes = {
	departmentId: PropTypes.string.isRequired,
	show: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	children: PropTypes.node.isRequired
};

export default StaffModal;
